import { SxProps, Theme } from '@mui/material';

// Función que recibe la imagen como parámetro y devuelve el objeto de estilos
export const getGridItemSX = (image: string): SxProps<Theme> => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100vw',
	padding: { xs: '20px', sm: '20px', md: '150px' },
	backgroundImage: `url(${image})`,
	minHeight: { xs: '350px', sm: '636px' },
	marginBottom: { xs: '20px', sm: '30px' },
});

export const titleSX: SxProps<Theme> = {
	fontSize: { sm: 'var(--font-size-biggest)', xs: 'var(--font-size-display)' },
	fontWeight: '800',
	color: 'white',
	textAlign: 'center',
	fontFamily: 'Open Sans',
};
